class ModalDemo extends React.Component {
  constructor() {
    super();

    this.state = {
      isModalOpen: [false, false]
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(modal) {
    let isModalOpen = this.state.isModalOpen;
    isModalOpen[modal] = true;
    this.setState({isModalOpen})
  }

  closeModal(modal) {
    let isModalOpen = this.state.isModalOpen;
    isModalOpen[modal] = false;
    this.setState({isModalOpen})
  }

  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="modal">
          Modal
          <span className="section__item-docs">
            Documentation:&nbsp;
            <a href="docs/components/class/components/Modal.jsx~Modal.html" target="_blank">JS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Modals</h4>
              <div className="demo__code">
                <CodeBlock lang="jsx">
                {`
@import {Modal} from 'airtame-gooey';

...

constructor {
  super();

  this.state = {
    isModalOpen: [false, false]
  };
  this.openModal = this.openModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
}

openModal(modal) {
  let isModalOpen = this.state.isModalOpen;
  isModalOpen[modal] = true;
  this.setState({isModalOpen})
}

closeModal(modal) {
  let isModalOpen = this.state.isModalOpen;
  isModalOpen[modal] = false;
  this.setState({isModalOpen})
}

...

render() {
  return(
    <div className="modal-demo">
      <button onClick={() => {this.openModal(0)}}>Modal 1</button>
      <Modal isOpen={this.state.isModalOpen[0]}
             onClose={() => {this.closeModal(0)}}
             className="modal1">
        <h2>This is my first modal</h2>
      </Modal>
      <button onClick={() => {this.openModal(1)}}>Modal 2</button>
      <Modal isOpen={this.state.isModalOpen[1]}
             onClose={() => {this.closeModal(1)}}
             className="modal2">
        <h2>This is my second modal</h2>
      </Modal>
    </div>
  )
}
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.modal-demo {
  .modal {
    @include modal();
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="modal-demo">
                    <button onClick={() => {this.openModal(0)}}>Modal 1</button>
                    <Modal isOpen={this.state.isModalOpen[0]}
                           onClose={() => {this.closeModal(0)}}
                           className="modal1">
                      <h2>This is my first modal</h2>
                    </Modal>
                    <button onClick={() => {this.openModal(1)}}>Modal 2</button>
                    <Modal isOpen={this.state.isModalOpen[1]}
                           onClose={() => {this.closeModal(1)}}
                           className="modal2">
                      <h2>This is my second modal</h2>
                    </Modal>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
